import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDUAY2NBgpxr2BvzhsXK_qb3t37Up-SHzg",
  authDomain: "clone-project-3ab3a.firebaseapp.com",
  databaseURL: "https://clone-project-3ab3a.firebaseio.com",
  projectId: "clone-project-3ab3a",
  storageBucket: "clone-project-3ab3a.appspot.com",
  messagingSenderId: "850640650285",
  appId: "1:850640650285:web:b5c178875f1caf084978a4",
  measurementId: "G-K78DB4VNP6"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export {db, auth};